import React from "react";
import { Container, Row, Col } from "shards-react";
import Contracts from "../components/contracts/Contracts";

const ContractsTable = () => (
  <Container fluid className="main-content-container px-4">
	  <Row>
      <Col className="p-2">
		    <Contracts /> 
      </Col>
    </Row>
   </Container>
);

export default ContractsTable;
